export const url = {
  save: '/auth/comment/save',
  list: '/auth/comment/findList',
  detail: '/auth/comment/find'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/comment.js